module.exports = __webpack_public_path__ + "static/img/13.6721f98.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/zh/13.png
// module id = sCke
// module chunks = 0